import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Details from '../views/Details.vue'
import Enquiry from '../views/Enquiry.vue'
import Project from '../views/Project.vue'
import AddProject from '../views/AddProject.vue'
import Help from '../views/Help.vue'
import Today from '../views/Today.vue'
import Meeting from '../views/Meeting.vue'
import MyMeeting from '../views/MyMeetings.vue'
import MeetingDetails from '../views/MeetingDetails.vue'
import AddMeeting from '../views/AddMeeting.vue'
import AddNewMeeting from '../views/AddNewMeeting.vue'
import InterestedBroker from '../views/InterestedBroker.vue'
import BrokerInitiation from '../views/BrokerInitiation.vue'
import InitiationDetails from '../views/InitiationDetails.vue'
import BrokerDetails from '../views/BrokerDetails.vue'
import ProjectDetails from '../views/ProjectDetails.vue'
import Campaign from '../views/Campaign.vue'
import CampaignList from '../views/CampaignList.vue'
import CampaignDetails from '../views/CampaignDetails.vue'
import AddCampaign from '../views/AddCampaign.vue'
import AddNewCampaigninMeetings from '../views/AddNewCampaigninMeetings.vue'
import EditCampaign from '../views/EditCampaign.vue'
import EditEnquiry from '../views/EditEnquiry.vue'
import EditMeeting from '../views/EditMeeting.vue'
import ManageCampaign from '../views/ManageCampaign.vue'
import ManageMeetingCampaign from '../views/ManageMeetingCampaign.vue'
import Impression from '../views/Impression.vue'
import ForgotPassword from '../views/Passwords/ForgotPassword.vue'
import ResetPassword from '../views/Passwords/ResetPassword.vue'
import Brokers from '../views/Brokers/Index.vue'
import CPBrokerDetails from '../views/Brokers/CPBrokerDetails.vue'
import EditCPBroker from '../views/Brokers/EditCPBroker.vue';
import CPCallLog from '../views/Brokers/CPCallLog.vue';
import CpEngagement from '../views/CpEngagement.vue'
import CpEngagementDetails from '../views/CpEngagementDetails.vue'
import CpDetail from '../views/CpDetail.vue'
import DailyStandUp from '../views/DailyStandUp.vue';
import DailyStandUpDetails from '../views/DailyStandUpDetails.vue';
import AddDailyStandUpMeeting from '../views/AddDailyStandUpMeeting.vue';
import EditDailyMeeting from '../views/EditDailyMeeting.vue';
import PrEnquries from '../views/Premium_Enquiry/Enquries.vue';
import EnqDetails from '../views/Premium_Enquiry/Details.vue';
import Eoi from '../views/Premium_Enquiry/Eoi.vue';
import SiteVisit from '../views/Premium_Enquiry/SiteVisit.vue';
import OTP from '../views/OTP.vue';
import MyCpMeeting from '../views/MyCpMeeting.vue';
import MyCpMeetingDetails from '../views/MyCpMeetingDetails.vue';
import EditMyCpMeeting from '../views/EditMyCpMeeting.vue'
import VisitingCard from '../views/VisitingCard.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/Details/:id',
    name: 'Details',
    component: Details
  },
  {
    path: '/Today/:page/:callType?',
    name: 'Today',
    component: Today
  },
  {
    path: '/Help/:name',
    name: 'Help',
    component: Help
  },
  {
    path: '/Enquiry',
    name: 'Enquiry',
    component: Enquiry
  },
  {
    path: '/otp',
    name: 'OTP',
    component: OTP
  },
  {
    path: '/Project',
    name: 'Project',
    component: Project
  },
  {
    path: '/Campaign',
    name: 'Campaign',
    component: CampaignList
  },
  {
    path: '/Campaign/:id',
    name: 'Campaign',
    component: Campaign
  },
  {
    path: '/AddCampaign/:id/:broker_id/:building_broker_id',
    name: 'AddCampaign',
    component: AddCampaign
  },
  {
    path: '/AddNewCampaigninMeetings/:id',
    name: 'AddNewCampaigninMeetings',
    component: AddNewCampaigninMeetings
  },
  {
    path: '/ManageCampaign/:id/:building_broker_id',
    name: 'ManageCampaign',
    component: ManageCampaign
  },
  {
    path: '/ManageMeetingCampaign/:id',
    name: 'ManageMeetingCampaign',
    component: ManageMeetingCampaign
  },
  {
    path: '/EditCampaign/:campaign_id',
    name: 'EditCampaign',
    component: EditCampaign
  },
  {
    path: '/EditEnquiry/:id',
    name: 'EditEnquiry',
    component: EditEnquiry
  },
  {
    path: '/EditMeeting/:id',
    name: 'EditMeeting',
    component: EditMeeting
  },
  {
    path: '/CampaignDetails/:id',
    name: 'CampaignDetails',
    component: CampaignDetails
  },
  {
    path: '/ProjectDetails/:id',
    name: 'ProjectDetails',
    component: ProjectDetails
  },
  {
    path: '/AddMeeting',
    name: 'AddMeeting',
    component: AddMeeting
  },
  {
    path: '/AddNewMeeting/:id',
    name: 'AddNewMeeting',
    component: AddNewMeeting
  },
  {
    path: '/Meeting',
    name: 'Meeting',
    component: Meeting
  },
  {
    path: '/McMeetings',
    name: 'Meeting',
    component: MyMeeting
  },
  {
    path: '/MeetingDetails/:id',
    name: 'MeetingDetails',
    component: MeetingDetails
  },
  {
    path: '/AddProject',
    name: 'AddProject',
    component: AddProject
  },
  {
    path: '/InterestedBroker/:id',
    name: 'InterestedBroker',
    component: InterestedBroker
  },
  {
    path: '/BrokerInitiation/:id',
    name: 'BrokerInitiation',
    component: BrokerInitiation
  },
  {
    path: '/InitiationDetails/:id/:brokerid',
    name: 'InitiationDetails',
    component: InitiationDetails
  },

  {
    path: '/BrokerDetails/:id/:brokerid',
    name: 'BrokerDetails',
    component: BrokerDetails
  },
  {
    path: '/Impression/:id',
    name: 'Impression',
    component: Impression
  },
  {
    path: '/forgotpassword',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
    path: '/Password/Edit',
    name: 'PasswordEdit',
    component: ResetPassword
  },
  {
    path:'/Brokers',
    name: 'ManageBrokers',
    component: Brokers
  },
  {
    path:'/Brokers/:brokerid',
    name: 'CPBrokerDetails',
    component: CPBrokerDetails
  },
   {
    path:'/Brokers/Edit/:brokerid',
    name: 'EditCPBroker',
    component: EditCPBroker
  },
  {
    path:'/Brokers/CPCallLog/:brokerid',
    name: 'CPCallLog',
    component: CPCallLog
  },
  {
    path: '/CpEngagement',
    name: 'CpEngagement',
    component: CpEngagement
  },
  {
    path: '/CpEngagementDetails/:id',
    name: 'CpEngagementDetails',
    component: CpEngagementDetails
  },
  {
    path: '/CpDetail/:id',
    name: 'CpDetail',
    component: CpDetail
  },
  {
    path: '/DailyStandUp',
    name: 'DailyStandUp',
    component: DailyStandUp
  },
  {
    path: '/DailyStandUpDetails/:id',
    name: 'DailyStandUpDetails',
    component: DailyStandUpDetails
  },
  {
    path: '/AddDailyStandUpMeeting',
    name: 'AddDailyStandUpMeeting',
    component: AddDailyStandUpMeeting
  },
  {
    path: '/EditDailyMeeting/:id',
    name: 'EditDailyMeeting',
    component: EditDailyMeeting
  },
  {
    path: '/login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
  },
  {
    path: '/PrEnquries',
    name: 'PrEnquries',
    component: PrEnquries
  },
  {
    path: '/EnqDetails/:id',
    name: 'EnqDetails',
    component: EnqDetails
  },
  {
    path: '/Eoi/:id',
    name: 'Eoi',
    component: Eoi
  },
  {
    path: '/SiteVisit/:id',
    name: 'SiteVisit',
    component: SiteVisit
  },
  {
    path: '/CpMeetingRequests',
    name: 'MyCpMeeting',
    component: MyCpMeeting
  },
  {
    path: '/MyCpMeetingDetails/:id',
    name: 'MyCpMeetingDetails',
    component: MyCpMeetingDetails
  },
  {
    path: '/EditMyCpMeeting/:id',
    name: 'EditMyCpMeeting',
    component: EditMyCpMeeting
  },
  {
    path: '/visiting-card',
    name: 'VisitingCard',
    component: VisitingCard
  }
]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  base: process.env.BASE_URL,
  routes
})


export default router
